/**
 * Created by Alican Köker on 2019-05-06.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {EdisonGameConfig} from "../EdisonGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineLite, TweenLite} from "gsap";
import {EdisonGameMode} from "../gameMode/EdisonGameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EdisonIndividualWPView} from "../winpresentation/individual/EdisonIndividualWPView";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {EdisonParsedGameData} from "../server/data/EdisonParsedGameData";
import {EdisonParsedInitData} from "../server/data/EdisonParsedInitData";

export class EdisonLogoView extends BaseView {

    private _layer:ScalableLayer;
    private _logoText:PIXI.Sprite;
    private _logoTop:PIXI.Sprite;
    private _gameMode:EdisonGameMode;
    private _nextMode:EdisonGameMode;
    private _orientation:Orientation = Orientation.LANDSCAPE;
    private _modeChangeAnimTimeline:TimelineLite;
    private _yPadding:number = 0;
    private _logoTextYPos:number = 37;
    private _logoTopYPos:number = -60;
    private _isRestore:boolean = false;

    constructor() {
        super();

        this._layer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.FOREGROUND.name);
        EventHandler.addEventListener(this, EdisonIndividualWPView.SET_MODE, (event:GameEvent) => this._gameMode = event.params[0]);
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:EdisonParsedGameData):void {
        this._isRestore = false;
        this._gameMode = data.mode;
    }

    protected onInitDataParsed(data:EdisonParsedInitData):void {
        this._isRestore = data.isRestoreState;
        this._gameMode = data.mode;
    }

    protected initAnimations():void {
        this._logoText = new PIXI.Sprite(GameResources.getTextures("logoText")[0]);
        this._logoTop = new PIXI.Sprite(GameResources.getTextures("logoTop")[0]);

        this._logoText.scale.set(.25);
        this._logoTop.scale.set(.4);

        this._layer.addChild(this._logoText);
        this._layer.addChild(this._logoTop);

        this._logoText.position.set(520, this._logoTextYPos);
        this._logoTop.position.set(532, this._logoTopYPos);
        this._logoTop.visible = false;
    }

    protected onResize(resizeData:IResizeData):void {

        let ratio:number = resizeData.width/resizeData.height;
        this._logoTop.visible = ratio < 25/35;

        if(this._orientation === resizeData.orientation)
            return;

        if(this._modeChangeAnimTimeline && this._modeChangeAnimTimeline.isActive()) {
            this._gameMode = this._nextMode;
            this._modeChangeAnimTimeline.pause();
            this._modeChangeAnimTimeline.kill();
        }

        this._orientation = resizeData.orientation;

        this._yPadding = resizeData.orientation === Orientation.PORTRAIT ? -120 : 0;

        this._logoText.position.set(520, this._logoTextYPos + this._yPadding);
        this._logoTop.position.set(532, this._logoTopYPos + this._yPadding);

    }

}